import useRachelChangesStore from '../store/rachelChanges.store';
import { rachelEventBus } from './rachelEventBus';
import type { UiEffect } from './uiEffect.schema';

export interface EffectCtx {
  navigate: (to: string) => void;
}

type EffectHandler<K extends UiEffect['kind']> = (
  effect: Extract<UiEffect, { kind: K }>,
  ctx: EffectCtx,
) => void;

const handleChanged: EffectHandler<'changed'> = (effect) => {
  useRachelChangesStore.getState().markChange(effect);
  rachelEventBus.publish(effect);
};

const handleNavigate: EffectHandler<'navigate'> = (effect, ctx) => {
  ctx.navigate(effect.to);
};

export const effectRegistry: { [K in UiEffect['kind']]: EffectHandler<K> } = {
  changed: handleChanged,
  navigate: handleNavigate,
};
